import { gridSize } from '@/shared/constants';
import { FormControl, Grid, MenuItem, TextField } from '@mui/material';

export type CustomSelectTextFieldNoFormProps<T> = {
  label?: string;
  required?: boolean;
  options: T[];
  defaultValue: string | number;
  labelKey: keyof T;
  valueKey: keyof T;
  menuItemKey: keyof T;
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  disabled?: boolean;
  onChangeValue?: (value: string) => void;
  onChangeRawValue?: (value: T) => void;
};

function CustomSelectTextFieldNoForm<T>({
  label,
  options,
  labelKey,
  valueKey,
  defaultValue,
  size = gridSize,
  menuItemKey,
  required = true,
  disabled = false,
  onChangeValue,
  onChangeRawValue,
}: Readonly<CustomSelectTextFieldNoFormProps<T>>) {
  const onChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedValue = event.target.value;
    const selectedItem = options.find(item => item[valueKey] === selectedValue);

    onChangeValue && onChangeValue(event.target.value as string);
    onChangeRawValue && onChangeRawValue(selectedItem as T);
  };

  return (
    <Grid item {...size}>
      <FormControl fullWidth variant="outlined">
        <TextField
          select
          label={label}
          variant="outlined"
          fullWidth
          defaultValue={defaultValue || ''}
          required={required}
          disabled={disabled}
          onChange={onChange}
        >
          {options.map((item: any) => {
            return (
              <MenuItem key={item[menuItemKey]} value={item[valueKey]}>
                {item[labelKey]}
              </MenuItem>
            );
          })}
        </TextField>
      </FormControl>
    </Grid>
  );
}

export default CustomSelectTextFieldNoForm;
